// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-decor {
  background-color: rgba(var(--white));
  box-sizing: border-box;
}
.project-decor__header {
  padding: 3rem 6.875rem 0;
}
@media (max-width: 768px) {
  .project-decor__header {
    padding: 1.75rem 1rem 1.25rem;
    height: 2.5rem;
  }
}
.project-decor__content {
  padding: 0 6.875rem 3rem;
}
@media (max-width: 768px) {
  .project-decor__content {
    padding: 0;
  }
}
.project-decor__title {
  font-size: 2rem;
  line-height: 1.3;
  font-weight: 500;
  color: rgba(var(--grey-800));
  margin-bottom: 3rem;
}
@media (max-width: 768px) {
  .project-decor__title {
    font-size: 1.5rem;
    line-height: 1.3;
    padding: 0 1rem;
    margin-top: 0.75rem;
    margin-bottom: 2rem;
  }
}
.project-decor__img1 {
  object-fit: cover;
  width: 100%;
  border-radius: 1.5rem;
  height: calc((100vw - 13.75rem) / 2);
}
@media (max-width: 768px) {
  .project-decor__img1 {
    border-radius: 0.75rem;
    height: calc((100vw - 2rem) / 1.88);
  }
}
.project-decor__img2 {
  object-fit: cover;
  width: 100%;
  border-radius: 1.5rem;
  height: calc((100vw - 10rem) / 2);
}
@media (max-width: 768px) {
  .project-decor__img2 {
    border-radius: 0.5rem;
    height: calc((100vw - 1.85rem) / 1.88);
  }
}
.project-decor__img3 {
  object-fit: cover;
  width: 100%;
  border-radius: 1.5rem;
  height: calc((100vw - 20rem) / 2);
}
@media (max-width: 768px) {
  .project-decor__img3 {
    border-radius: 0.75rem;
    height: calc((100vw - 5rem) / 1.88);
  }
}
.project-decor__imgs {
  display: flex;
  align-items: center;
  gap: 2.5rem;
  margin-top: 2.3rem;
}
@media (max-width: 768px) {
  .project-decor__imgs {
    gap: 0.75rem;
    margin-top: 0.75rem;
  }
}
.project-decor__imgs2 {
  display: flex;
  align-items: center;
  gap: 2.5rem;
  margin-bottom: 2.3rem;
}
@media (max-width: 768px) {
  .project-decor__imgs2 {
    gap: 0.6875rem;
    margin-bottom: 0.6875rem;
  }
}
.project-decor__text {
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.66;
  color: rgba(var(--grey-800));
  white-space: pre-line;
  margin-bottom: 2.5rem;
}
@media (max-width: 768px) {
  .project-decor__text {
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
    margin-bottom: 1rem;
  }
}
.project-decor__block {
  margin-bottom: 5rem;
}
@media (max-width: 768px) {
  .project-decor__block {
    padding: 0 1rem;
    margin-bottom: 3rem;
  }
}
.project-decor__block:last-child {
  margin-bottom: 6.25rem;
}
@media (max-width: 768px) {
  .project-decor__block:last-child {
    margin-bottom: 3.5rem;
  }
}
.project-decor__block-title {
  font-weight: 500;
  font-size: 2.5rem;
  line-height: 1.25;
  color: rgba(var(--grey-800));
  margin-bottom: 1rem;
}
@media (max-width: 768px) {
  .project-decor__block-title {
    font-size: 1.5rem;
    line-height: 1.3;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ProjectDecor/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,sBAAA;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,6BAAA;IACA,cAAA;EAEJ;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,UAAA;EAEJ;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;AACJ;AACI;EAPF;IAQI,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;IACA,mBAAA;EAEJ;AACF;AACE;EACE,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,oCAAA;AACJ;AACI;EANF;IAOI,sBAAA;IACA,mCAAA;EAEJ;AACF;AACE;EACE,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,iCAAA;AACJ;AACI;EANF;IAOI,qBAAA;IACA,sCAAA;EAEJ;AACF;AACE;EACE,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,iCAAA;AACJ;AACI;EANF;IAOI,sBAAA;IACA,mCAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AACJ;AACI;EANF;IAOI,YAAA;IACA,mBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AACJ;AACI;EANF;IAOI,cAAA;IACA,wBAAA;EAEJ;AACF;AACE;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,4BAAA;EACA,qBAAA;EACA,qBAAA;AACJ;AACI;EARF;IASI,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;EAEJ;AACF;AACE;EACE,mBAAA;AACJ;AACI;EAHF;IAII,eAAA;IACA,mBAAA;EAEJ;AACF;AAAI;EACE,sBAAA;AAEN;AAAM;EAHF;IAII,qBAAA;EAGN;AACF;AAAI;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,4BAAA;EACA,mBAAA;AAEN;AAAM;EAPF;IAQI,iBAAA;IACA,gBAAA;EAGN;AACF","sourcesContent":[".project-decor {\n  background-color: rgba(var(--white));\n  box-sizing: border-box;\n\n  &__header {\n    padding: 3rem 6.875rem 0;\n\n    @media (max-width: 768px) {\n      padding: 1.75rem 1rem 1.25rem;\n      height: 2.5rem;\n    }\n  }\n\n  &__content {\n    padding: 0 6.875rem 3rem;\n\n    @media (max-width: 768px) {\n      padding: 0;\n    }\n  }\n\n  &__title {\n    font-size: 2rem;\n    line-height: 1.3;\n    font-weight: 500;\n    color: rgba(var(--grey-800));\n    margin-bottom: 3rem;\n\n    @media (max-width: 768px) {\n      font-size: 1.5rem;\n      line-height: 1.3;\n      padding: 0 1rem;\n      margin-top: 0.75rem;\n      margin-bottom: 2rem;\n    }\n  }\n\n  &__img1 {\n    object-fit: cover;\n    width: 100%;\n    border-radius: 1.5rem;\n    height: calc((100vw - 13.75rem) / 2);\n\n    @media (max-width: 768px) {\n      border-radius: 0.75rem;\n      height: calc((100vw - 2rem) / 1.88);\n    }\n  }\n\n  &__img2 {\n    object-fit: cover;\n    width: 100%;\n    border-radius: 1.5rem;\n    height: calc((100vw - 10rem) / 2);\n\n    @media (max-width: 768px) {\n      border-radius: 0.5rem;\n      height: calc((100vw - 1.85rem) / 1.88);\n    }\n  }\n\n  &__img3 {\n    object-fit: cover;\n    width: 100%;\n    border-radius: 1.5rem;\n    height: calc((100vw - 20rem) / 2);\n\n    @media (max-width: 768px) {\n      border-radius: 0.75rem;\n      height: calc((100vw - 5rem) / 1.88);\n    }\n  }\n\n  &__imgs {\n    display: flex;\n    align-items: center;\n    gap: 2.5rem;\n    margin-top: 2.3rem;\n\n    @media (max-width: 768px) {\n      gap: 0.75rem;\n      margin-top: 0.75rem;\n    }\n  }\n\n  &__imgs2 {\n    display: flex;\n    align-items: center;\n    gap: 2.5rem;\n    margin-bottom: 2.3rem;\n\n    @media (max-width: 768px) {\n      gap: 0.6875rem;\n      margin-bottom: 0.6875rem;\n    }\n  }\n\n  &__text {\n    font-weight: 500;\n    font-size: 1.5rem;\n    line-height: 1.66;\n    color: rgba(var(--grey-800));\n    white-space: pre-line;\n    margin-bottom: 2.5rem;\n\n    @media (max-width: 768px) {\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.5;\n      margin-bottom: 1rem;\n    }\n  }\n\n  &__block {\n    margin-bottom: 5rem;\n\n    @media (max-width: 768px) {\n      padding: 0 1rem;\n      margin-bottom: 3rem;\n    }\n\n    &:last-child {\n      margin-bottom: 6.25rem;\n\n      @media (max-width: 768px) {\n        margin-bottom: 3.5rem;\n      }\n    }\n\n    &-title {\n      font-weight: 500;\n      font-size: 2.5rem;\n      line-height: 1.25;\n      color: rgba(var(--grey-800));\n      margin-bottom: 1rem;\n\n      @media (max-width: 768px) {\n        font-size: 1.5rem;\n        line-height: 1.3;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
